import { IPdfUsage } from 'interfaces';

import { IGetOverallPdfUsageTableDataParams, IGroupedPdfUsage, IOverallPdfUsageTableData } from './OverallPdfTableView.interfaces';


const  groupAndSumPdfUsage = (pdfUsages: IPdfUsage[]): IGroupedPdfUsage[] => {
  const map: { [key: string]: IGroupedPdfUsage } = {};

  pdfUsages.forEach(item => {
    const date = item.dateLocaleDateString;
    const apiKey = item.apiKey.title;
    const key = `${date}|${apiKey}`;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (!map[key]) {
      map[key] = {
        date,
        apiKey,
        count: 0,
      };
    }
    map[key].count += item.count;
  });

  return Object.values(map).sort((a, b) => b.date.localeCompare(a.date));
}

const getOverallPdfUsageTableData = ({ pdfUsages }: IGetOverallPdfUsageTableDataParams): IOverallPdfUsageTableData[] => {
  return pdfUsages.map(
    ({ apiKey, count, date }): IOverallPdfUsageTableData => {
      return {
        id: `${apiKey}-${date}`,
        apiKey,
        count,
        date,
      }
    },
  );
};

export { getOverallPdfUsageTableData, groupAndSumPdfUsage };
